// removed by extract-text-webpack-plugin
module.exports = {"Email":"_1dOX5","Number":"_3GyeO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/DetailForm/DetailForm.scss
// module id = 538
// module chunks = 0